module.exports = __webpack_public_path__ + "img/pg3_object.0db567d3.png";